<div
	class="app-container"
	[ngClass]="[isAuthenticated && !isAdminApplication ? 'withNavbar' : !isAuthenticated ? 'withoutNavbar' : '', class]"
>
	<ng-content />
</div>
